export default "/assets/images/smiling-face-with-smiling-eyes.png?d23422f528e2b7052f918dd49e63505d";